import React from 'react';
import { Group, Text } from '@mantine/core';
import { IconEye } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

/**
 * Quiet, dimmed caption marking a section as visible to healthcare
 * professionals only (AMI-637). Surfaces existing access control — these
 * sections are never rendered for patients — so the HCP knows who can see the
 * content. Positive framing ("visible to HCP" rather than "hidden from
 * patient") keeps the cue reassuring rather than restrictive.
 */
const HcpOnlyCaption: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Group gap={4} align="center" wrap="nowrap" c="dimmed">
      <IconEye size={14} stroke={1.5} />
      <Text size="xs" c="dimmed">
        {t('common.visibleToHcpOnly')}
      </Text>
    </Group>
  );
};

export default HcpOnlyCaption;
